/* if you modify this file, please remove this line then fix eslint errors. */ /* eslint-disable */
import ExtendableError from 'es6-error';

export default class XMLHttpRequestException extends ExtendableError {
  constructor({ headers, status, responseJSON, responseText, statusText, data }) {
    super();
    this.headers = headers;
    this.status = status;
    this.statusText = statusText;
    this.responseText = responseText;
    this.responseJSON = responseJSON;
  }
}
